module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mall-header'), _vm._v(" "), _c('mall-bread', [_c('span', {
    staticStyle: {
      "color": "#999"
    },
    attrs: {
      "to": "/orderConfirm"
    }
  }, [_vm._v("确认订单信息")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.fullscreenLoading),
      expression: "fullscreenLoading",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    staticClass: "orderConfirm-div"
  }, [_c('span', {
    staticClass: "orderConfirm-div-titel"
  }, [_vm._v("确认订单信息")]), _vm._v(" "), _c('table', {
    staticClass: "orderConfirm-table"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.orderData.orderDetails), function(datas, i) {
    return _c('tr', {
      key: i,
      staticClass: "orderConfirm-table-tr-content"
    }, [_c('td', [_c('span', {
      staticStyle: {
        "margin-left": "20px"
      }
    }, [_c('img', {
      staticStyle: {
        "width": "68px",
        "height": "68px",
        "cursor": "pointer"
      },
      attrs: {
        "src": datas.itemImgUrl
      },
      on: {
        "click": function($event) {
          return _vm.openGoodsDetails(datas.serviceItemId)
        }
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "orderConfirm-table-tr-span",
      on: {
        "click": function($event) {
          return _vm.openGoodsDetails(datas.serviceItemId)
        }
      }
    }, [_vm._v(_vm._s(datas.supplierName))])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v("￥" + _vm._s(datas.unitPrice))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(datas.quantity) + "份")]), _vm._v(" "), _c('td', {
      staticClass: "orderConfirm-table-td"
    }, [_vm._v("￥" + _vm._s(datas.amount))])])
  })], 2), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "orderConfirm-div-payType"
  }, [_vm._v("选择支付方式")]), _vm._v(" "), _c('div', {
    staticClass: "orderConfirm-payType-div"
  }, [_c('div', {
    class: _vm.isSelectWX ? _vm.wxpayInitDiv : _vm.wxpaySelectedDiv,
    on: {
      "click": function($event) {
        return _vm.selectWX()
      }
    }
  }, [_c('svg', {
    class: _vm.isSelectWX ? _vm.wxpayInitImg : _vm.wxpaySelectedImg,
    attrs: {
      "aria-hidden": "false"
    }
  }, [_c('use', {
    attrs: {
      "fill": "#4CAF50",
      "xlink:href": "#weixinzhifu"
    }
  })]), _vm._v(" "), _c('span', {
    class: _vm.wxpayInitFont
  }, [_vm._v("微信支付")]), _vm._v(" "), (!_vm.isSelectWX) ? _c('img', {
    staticStyle: {
      "width": "12px",
      "height": "8px",
      "float": "right",
      "margin-top": "3px",
      "margin-right": "3px"
    },
    attrs: {
      "src": require("../../static/images/勾选.png")
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    class: _vm.isSelectali ? _vm.alipayInitDiv : _vm.alipaySelectedDiv,
    on: {
      "click": function($event) {
        return _vm.selectAli()
      }
    }
  }, [_c('svg', {
    class: _vm.isSelectali ? _vm.alipayInitImg : _vm.alipaySelectedImg,
    attrs: {
      "aria-hidden": "false"
    }
  }, [_c('use', {
    attrs: {
      "fill": "#2698E4",
      "xlink:href": "#zhifubaozhifu"
    }
  })]), _vm._v(" "), _c('span', {
    class: _vm.alipayInitFont,
    staticStyle: {}
  }, [_vm._v("支付宝支付")]), _vm._v(" "), (!_vm.isSelectali) ? _c('img', {
    staticStyle: {
      "width": "12px",
      "height": "8px",
      "float": "right",
      "margin-top": "3px",
      "margin-right": "3px"
    },
    attrs: {
      "src": require("../../static/images/勾选.png")
    }
  }) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "orderConfirm-yingfu-div"
  }, [_c('span', {
    staticClass: "orderConfirm-yingfu-total"
  }, [_vm._v("应付总额：")]), _vm._v(" "), _c('span', {
    staticClass: "orderConfirm-yingfu-money"
  }, [_vm._v("￥" + _vm._s(_vm.orderData.totalAmount))]), _vm._v(" "), _c('button', {
    staticClass: "orderConfirm-yingfu-button",
    attrs: {
      "disabled": _vm.isDisable
    },
    on: {
      "click": _vm.nowPay
    }
  }, [_vm._v("立即支付")])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both",
      "height": "149px"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "left": "0px",
      "bottom": "0px",
      "width": "100%",
      "z-index": "1",
      "text-align": "center",
      "padding": "20px 0",
      "color": "#999999",
      "font-size": "14px"
    }
  }, [_vm._v("\n    Copyright ©2021 深圳市东宝信息技术有限公司 All Rights Reserved\n  ")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "orderConfirm-table-tr-head"
  }, [_c('td', {
    staticStyle: {
      "float": "left",
      "margin-left": "-265px",
      "margin-top": "7px"
    },
    attrs: {
      "width": "600px"
    }
  }, [_vm._v("商品")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "200px"
    }
  }, [_vm._v("单价")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "200px"
    }
  }, [_vm._v("数量")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "200px"
    }
  }, [_vm._v("小计")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "orderConfirm-foot-div"
  }, [_c('span', {
    staticClass: "orderConfirm-foot-remark"
  }, [_vm._v("说明")]), _vm._v(" "), _c('span', {
    staticClass: "orderConfirm-foot-font"
  }, [_vm._v("购买过程中如您遇到任何问题，可随时与我们联系：")]), _vm._v(" "), _c('span', {
    staticClass: "orderConfirm-foot-font"
  }, [_vm._v("1、拨打客服电话：400-788-5678 ")]), _vm._v(" "), _c('span', {
    staticClass: "orderConfirm-foot-font"
  }, [_vm._v("2、支付完成之后可在【我的订单>发票管理】开具发票")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-77a54316!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/OrderConfirm.vue
// module id = 335
// module chunks = 2